<template>
  <div class="com">
    <div class="desc">
      Thanks! Now it’s time to send in your samples for analysis.
    </div>
    <ul class="instructions-left">
      <li>
        <span>1</span>
        Make sure all of the used cassettes are back in Box #2, in the same
        slots they came in.
      </li>
      <li>
        <span>2</span>
        Remove the protective cover from the adhesive strip on the inner lid of
        Box #2.
      </li>
      <li>
        <span>3</span>
        Now, seal the box and drop it in the mail. The postage has been prepaid!
      </li>
    </ul>
    <p class="bottom-text">
      You will receive an update when your samples arrive at the lab. You can
      expect your report in less than a week!
    </p>

    <div class="btn-wrap">
      <button class="btn" @click="switchStep">Continue</button>
    </div>
  </div>
</template>

<script>
import FinalInfo from "../FinalInfo";

export default {
  name: "Instructions",
  data() {
    return {
      term_and_condition: false,
      sampling_detail: false
    };
  },
  components: {
    FinalInfo
  },
  methods: {
    showTerms() {
      this.$emit("showTerms", true);
    },
    switchStep() {
      this.$emit("nextStep", 1);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
b {
  font-weight: bold;
}

.instructions-left {
  text-align: center;
  list-style: none;
  margin-top: 60px;
}
.instructions-left li {
  color: $blue;
  margin-top: 55px;
  position: relative;
  font-family: TTNormsMedium, sans-serif;
  font-size: 16px;
  span {
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    top: -41px;
    transform: translate(-50%);
    font-size: 16px;
    font-family: TTNormsBold, sans-serif;
    color: $blue;
    border: 3px solid $blue;
    border-radius: 50%;
  }
}

.desc {
  color: $gray;
  width: 100%;
  margin: 20px auto;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
  font-family: TTNormsRegular, sans-serif;
}
.bottom-text {
  color: $gray;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  font-family: TTNormsRegular, sans-serif;
  margin-top: 36px;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  max-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
@media (max-width: 568px) {
  .instructions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .instructions img {
    height: auto;
    width: 100%;
  }
}
</style>
